import React, { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Modal, Row, Col, Button, Alert as BSALert, DropdownButton, Dropdown } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import Alert from "react-s-alert";
import * as Yup from "yup";
import { connect } from "react-redux";

import { CheckboxColumn, Input, RichText } from "../../../formik";
import {
  eventUpdateEmailContent,
  eventSendEmail,
} from "../../../redux/actions";

const EmailModal = ({
  show,
  close,
  speakers,
  speakersWithoutPresentations,
  speakersWithoutVideos,
  intl,
  event,
  dispatch,
}) => {
  const [sending, setSending] = useState(false);
  const saveContent = (values) => {
    dispatch(
      eventUpdateEmailContent(event._id, {
        emailSubject: values.subject,
        emailContent: values.content,
      })
    )
      .then((resp) => {
        Alert.success(intl.formatMessage({ id: resp.message }));
      })
      .catch((err) => Alert.error(intl.formatMessage({ id: err.message })));
  };

  const sendEmail = (values) => {
    const { speakers, cc, bcc, subject, content } = values;
    const email = {
      subject,
      content,
    };
    if (cc) {
      email.cc = cc;
    }
    if (bcc) {
      email.bcc = bcc;
    }
    setSending(true)
    Alert.warning("Please wait, we are sending the emails", {
      timeout: 'none',
    })
    dispatch(eventSendEmail(event._id, speakers, email))
      .then(() => {
        Alert.success(intl.formatMessage({ id: "email.success" }));
        close();
      })
      .catch((err) => Alert.error(intl.formatMessage({ id: err.message })))
      .finally(() => {
        setSending(false);
      });
  };

  return (
    <Modal className="email-modal" show={show !== false} onHide={close} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="email.heading.one" />
          <h5><FormattedMessage id="email.heading.two" /></h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          onSubmit={(values) => {
            // console.log(values);
            if(values.speakers.length === 0) {
              alert("Please select atleast one speaker")
              return
            }
            sendEmail(values)
          }}
          validationSchema={Yup.object().shape({
            speakers: Yup.array(),
            cc: Yup.string().email(),
            bcc: Yup.string().email(),
            subject: Yup.string().required(),
            content: Yup.string().required(),
            // .matches(
            //   /\[UPLOAD_URL\]/,
            //   "[UPLOAD_URL] should be present in the email content"
            // ),
          })}
          className="input-custom"
          initialValues={{
            speakers: [],
            cc: "",
            bcc: "",
            subject:
              event.emailSubject ||
              `${intl.formatMessage({ id: "form.email-default-subject" })} ${
                event.name
              }`,
            content:
              event.emailContent ||
              intl.formatMessage({ id: "form.email-default-message" }),
          }}
          render={({ values, setFieldValue }) => (
            <Form>
              <Row>
                <Col md={4}>
                  <div className="speakers-column">
                    <h4><FormattedMessage id="email.speakers.select" /><br/><FormattedMessage id="email.speakers.select2" /></h4>
                    <Button
                      onClick={() =>
                        setFieldValue("speakers", speakersWithoutPresentations)
                      }
                      className="common-btn-style m-t-20"
                      block
                      variant="primary"
                    >
                      <img src="/icons/plus-icon.svg" alt="plus" />
                      <FormattedMessage id="form.select-speakers-without-ppt" />
                    </Button>
                    <Button
                      onClick={() =>
                        setFieldValue("speakers", speakersWithoutVideos)
                      }
                      className="common-btn-style-dark m-t-10"
                      block
                      variant="primary"
                    >
                      <img src="/icons/plus-icon.svg" alt="plus" />
                      <FormattedMessage id="form.select-speakers-without-video" />
                    </Button>
                    <Field
                      name="speakers"
                      options={speakers}
                      component={CheckboxColumn}
                    />
                  </div>
                </Col>
                <Col md={8}>
                  <div className="mail-container">
                    <h4>Message</h4>
                    <Row>
                      <Col md={6}>
                        <Field
                          name="cc"
                          label={intl.formatMessage({ id: "form.cc" })}
                          // placeholder={intl.formatMessage({
                          //   id: "form.cc",
                          // })}
                          component={Input}
                          type="email"
                          inline
                        />
                      </Col>
                      <Col md={6}>
                        <Field
                          name="bcc"
                          label={intl.formatMessage({ id: "form.bcc" })}
                          // placeholder={intl.formatMessage({
                          //   id: "form.bcc",
                          // })}
                          component={Input}
                          type="email"
                          inline
                        />
                      </Col>
                      <Col md={12}>
                        <Field
                          name="subject"
                          label={intl.formatMessage({ id: "form.email-subject" })}
                          // placeholder={intl.formatMessage({
                          //   id: "form.email-subject",
                          // })}
                          component={Input}
                          inline
                        />
                      </Col>
                      <Col md={12}>
                        <label className="form-label">{intl.formatMessage({ id: "input.emailContent" })}</label>
                        <br/>
                        <DropdownButton className="load-email-dd m-t-20" id="dropdown-basic-button" title={intl.formatMessage({id: 'load.email'})}>
                          {event.emailSubject && <Dropdown.Item onClick={() => {
                              setFieldValue(
                                "subject",
                                event.emailSubject
                              );
                              setFieldValue(
                                "content",
                                event.emailContent
                              );
                              }} href="#">{intl.formatMessage({id: 'form.email-load-saved'})}</Dropdown.Item>}
                          <Dropdown.Item onClick={() => {
                              setFieldValue(
                                "subject",
                                `${intl.formatMessage({
                                  id: "form.email-default-subject",
                                })} ${event.name}`
                              );
                              setFieldValue(
                                "content",
                                intl.formatMessage({ id: "form.email-default-message" })
                              );
                              }} href="#">{intl.formatMessage({id: 'form.email-load-default'})}</Dropdown.Item>
                          <Dropdown.Item href="#"
                            onClick={
                              () => {
                                setFieldValue(
                                  "subject",
                                  `${intl.formatMessage({
                                    id: "form.email-virtual-subject",
                                  })} ${event.name}`
                                );
                                setFieldValue(
                                  "content",
                                  `${intl.formatMessage({
                                    id: "form.email-virtual-message",
                                  })}`
                                );
                              }
                            }
                          >
                            {intl.formatMessage({id: 'form.email.virtual'})}
                          </Dropdown.Item>
                        </DropdownButton>
                        <Field
                          component={RichText}
                          name="content"
                          // label={intl.formatMessage({
                          //   id: "input.emailContent",
                          // })}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-right">
                        <Button
                          className="common-btn-style-dark m-r-10"
                          onClick={() => saveContent(values)}
                        >
                          {intl.formatMessage({ id: "form.email-save" })}
                        </Button>
                        <Button disabled={sending} className="common-btn-style" type="submit" variant="primary">
                          <FormattedMessage id="form.send-email" />
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              {/* <pre>{JSON.stringify({ values, errors }, null, 2)}</pre> */}
              
              {/* <Button
                className="btn btn-default"
                
              >
                {intl.formatMessage({ id: "form.email-load-saved" })}
              </Button> */}
              {/* <Button
                className="btn btn-default"
                
              >
                {intl.formatMessage({
                  id: "form.email-load-default",
                })}
              </Button> */}
              <br />
              <br />
              <BSALert className="custom-alert-mail" variant="info">
                <BSALert.Heading>
                  <FormattedMessage id="heading.substitutions" />
                </BSALert.Heading>
                <Row>
                  <Col md={6}>
                    <b>[SPEAKER_NAME]</b> -{" "}
                    <FormattedMessage id="sub.speaker_name" />
                    <br />
                    <b>[UPLOAD_URL]</b> -{" "}
                    <FormattedMessage id="sub.upload_url" />
                    <br />
                    <b>[VIDEO_UPLOAD_URL]</b> -{" "}
                    <FormattedMessage id="sub.video_upload_url" />
                    <br />
                    <b>[PHOTO_UPLOAD_URL]</b> -{" "}
                    <FormattedMessage id="sub.photo_upload_url" />
                    <br />
                    <b>[VIDEO_WATCH_URL]</b> -{" "}
                    <FormattedMessage id="sub.video_watch_url" />
                    <br />
                    <b>[UPLOAD_BY_DATE]</b> -{" "}
                    <FormattedMessage id="sub.due_date" />
                    <br />
                    <b>[EVENT_LOGO]</b> -{" "}
                    <FormattedMessage id="sub.event_logo" />
                  </Col>
                  <Col md={6}>
                    <b>[EVENT_SLUG]</b> - Event Slug
                    <br />
                    <b>[SPEAKER_LOGIN]</b> - Speaker login (email)
                    <br />
                    <b>[SPEAKER_PASSWORD]</b> - Speaker password
                    <br />
                    <b>[SOFTWARE_LINK_FR]</b> - Link to download Windows software (French)
                    <br />
                    <b>[SOFTWARE_LINK_EN]</b> - Link to download Windows software (English)
                  </Col>
                </Row>
              </BSALert>
            </Form>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(injectIntl(EmailModal));
